"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@apollo/client/core");
var appointment = {
    APPOINTMENT_DETAILS: core_1.gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    fragment AppointmentDetails on Appointment {\n      preferredDate\n      preferredTime\n      comments\n      attributes {\n        salesConsultant\n      }\n    }\n  "], ["\n    fragment AppointmentDetails on Appointment {\n      preferredDate\n      preferredTime\n      comments\n      attributes {\n        salesConsultant\n      }\n    }\n  "]))),
};
exports.default = appointment;
var templateObject_1;
